import React from 'react';
import { connect } from 'react-redux'
import { commonType, sessionType } from './initialStoreValues';

import {Helmet} from "react-helmet";

import { startSession } from './actions'
import CustomHtmlParser from './components/CustomHtmlParser'
import Wizard from './components/Wizard'

import {sessionStates} from "./constants/states"
import { storePreconsentData } from './helpers/consent';

//import $ from 'jquery';

const LoadingScreen = (props) =>
<>
    <div className={props.fadeEffect === true? "overlay" : "overlay fadeOut"}></div>
    <div className={props.fadeEffect === true? "d-flex justify-content-center" : "d-flex justify-content-center fadeOut"}>
        <div className={props.fadeEffect === true? "spinner-border overlay-large-spinner text-light" : "spinner-border large-spinner text-light fadeOut"} role="status"></div>
    </div>
</>

const Screen404 = (props) => 
<div id="screen404Content" className="card col-11 col-md-8 mx-auto mt-4 mb-5">
    <div className="card-body justify-content-center">
        <h1>404 Page Not Found</h1>
    </div>
</div>

const ScreenCriticalError = (props) => 
<div id="screenCriticalErrorContent" className="card col-11 col-md-8 mx-auto mt-4 mb-5">
    <div className="card-body justify-content-center">
        <h1>Something went wrong</h1>
        <p>{props.message}</p>
    </div>
</div>


class App extends React.Component {

    extractJwtFromPath(path) {
        // Check if path starts with 'initialise' and extract JWT token
        if (path.startsWith('/initialise')) {
            const jwtToken = path.replace('/initialise', '');
            return jwtToken || null;
        }
        return null;
    }

    decodeJwtPayload(token) {
        try {
            // JWT has 3 parts separated by dots: header.payload.signature
            const parts = token.split('.');
            if (parts.length !== 3) {
                throw new Error('Invalid JWT format');
            }

            // Decode the payload (second part)
            const payload = parts[1];
            
            // Add padding if needed for base64 decoding
            const paddedPayload = payload + '='.repeat((4 - payload.length % 4) % 4);
            
            // Decode base64 and parse JSON
            const decodedPayload = JSON.parse(atob(paddedPayload));
            
            return decodedPayload;
        } catch (error) {
            console.error('Error decoding JWT:', error);
            return null;
        }
    }

    isJwtExpired(decodedPayload) {
        if (!decodedPayload || !decodedPayload.exp) {
            console.error('JWT payload missing or no expiration time found');
            return true; // Consider as expired if no exp field
        }

        const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        const expirationTime = decodedPayload.exp;

        //console.log('Current time:', currentTime);
        //console.log('JWT expiration time:', expirationTime);
        //console.log('Time remaining:', expirationTime - currentTime, 'seconds');

        return currentTime >= expirationTime;
    }

    componentDidMount() {
        let requestedPath = window.location.pathname
        
        //console.log('Requested path:', requestedPath);

        // Check if this is an initialization request with JWT token
        const jwtToken = this.extractJwtFromPath(requestedPath);
        
        if (jwtToken) {
            //console.log('JWT Token found:', jwtToken);
            
            // Decode JWT to get client information
            const decodedPayload = this.decodeJwtPayload(jwtToken);
            
            if (decodedPayload) {
                //console.log('Decoded JWT payload:', decodedPayload);

                // Check if JWT is expired
                if (this.isJwtExpired(decodedPayload)) {
                    //console.error('JWT token has expired');
                    this.props.dispatch({
                        type: 'CRITICAL_ERROR', 
                        message: 'Your session has expired. Please request a new link.'
                    });
                    return;
                }
                
                // Extract client code and redirect URL from JWT payload
                const clientCode = decodedPayload.client || '';
                if(!clientCode) {
                    //console.error('Client code missing in JWT payload');
                    this.props.dispatch({
                        type: 'CRITICAL_ERROR', 
                        message: 'Invalid session data. Please request a new link.'
                    });
                    return;
                }
                //const redirectUrl = `/${clientCode}` || '/';
                
                //console.log('Redirecting to client page:', redirectUrl);
                
                // Store user data if needed
                if (decodedPayload.given_name || decodedPayload.surname || decodedPayload.email) {
                    storePreconsentData(decodedPayload);
                }

                this.props.dispatch(startSession(clientCode, this.props.common.whitelabel));
                return;
                
                // Clean the URL and redirect
                //window.history.replaceState({}, document.title, redirectUrl);
                //window.location.href = redirectUrl;
                
                //return; // Exit early to prevent normal session start
            } else {
                //console.error('Failed to decode JWT token');
                // Fallback to 404 or error page
                this.props.dispatch({type: 'SESSION_START_ERROR'});
                return;
            }
        }

        this.props.dispatch(startSession(requestedPath, this.props.common.whitelabel));
    }
   
    render() {
        this.theme = this.props.common.theme
        let session = this.props.session        
        let header = <CustomHtmlParser data={this.theme.header}/>
        let info = "";// wl illion and all other hardcoded wls do not have info section, so default info to '';
        if(this.theme.info){
            info=<CustomHtmlParser data={this.theme.info}/>;
        }
        let footer = <CustomHtmlParser data={this.theme.footer}/>

        if(this.theme.favicon){
            document.getElementById("favicon").href = this.theme.favicon
        }

        return (
        <>
        <Helmet>
            {this.props.common.whitelabel === "" ? null : <link rel="stylesheet" type="text/css" href={"/whitelabel/" + this.props.common.whitelabel + "/wl.css"} />}
            <style type="text/css">{this.props.common.style}</style>

        </Helmet>
        <div className="d-flex flex-fill flex-column">
            
            {session.state === sessionStates.SESSION_STARTED && this.props.common.themeReady ? <>{header}<div className="mainWrapper"><Wizard /></div>{info}{footer}</>: null}

            {session.state === sessionStates.SESSION_NOT_INIT && !this.props.common.themeReady ? <LoadingScreen fadeEffect={true} /> : <LoadingScreen fadeEffect={false} /> }

            {session.state === sessionStates.SESSION_START_ERROR ? <>{header}<Screen404 />{footer}</> : null}

            {session.state === sessionStates.CRITICAL_ERROR ? <>{header}<ScreenCriticalError message={session.error.message} />{footer}</> : null}

        </div>        
        </>
        
        );
    }
}

App.propTypes = {
    common: commonType.isRequired,
    session: sessionType.isRequired
}

const mapStateToProps = (state) => {
    return {
        common : state.common,
        session: state.session
    }
}

export default connect(mapStateToProps)(App);